import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "@mui/material";
import { styled as style } from "@mui/material/styles";
import { useMutation } from "react-query";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Modal, Button as RsuiteBtn } from "rsuite";
import Logger from "../../libraries/Logger";
import apiClient from "../../libraries/ApiClient";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px;
  position: sticky;
  top: 0px;
  .title {
    font-size: 20px;
    color: #252525;
  }
  .btn {
    width: 150px;
    display: flex;
    justify-content: space-between;
  }
  @media (max-width: 1200px) {
    top: 50px;
    background-color: #fff;
    z-index: 8;
  }
`;

const CssCancelButton = style(Button)({
  fontSize: 12,
  borderColor: "#057AFF",
  backgroundColor: "#fff",
  padding: "3px 0px",
  "&:hover": {
    borderColor: "#1570EF",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
});

const CssSaveButton = style(Button)({
  fontSize: "12px",
  backgroundColor: "#057AFF",
  padding: "4px 0px",
  boxShadow: "none",
  borderColor: "#057AFF",
  "&:hover": {
    backgroundColor: "#1570EF",
    cursor: "pointer",
    boxShadow: "none",
    borderColor: "#057AFF",
  },
});

function AddDataTitle({ sendData, sendMediaData }) {
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [accountId, setAccountId] = useState("");
  const apiUrl = import.meta.env.VITE_API_ROOT_URL;

  const [open, setOpen] = useState(false);
  const [isLoadingOpen, setIsLoadingOpen] = useState(false);

  const [sendMediaCode, setSendMediaCode] = useState(null);
  const [sendMediaMessage, setSendMediaMessage] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const currentToken = JSON.parse(localStorage.getItem("auth"))?.Token;
  const currentAccountRowId = JSON.parse(
    localStorage.getItem("auth")
  )?.AccountRowId;

  // useEffect(() => {
  //   setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
  //   setAccountId(JSON.parse(localStorage.getItem("auth"))?.AccountRowId);
  // }, []);

  function hasDecimal(number) {
    const numberStr = number?.toString();

    const decimalPattern = /\./;

    return decimalPattern.test(numberStr);
  }

  const sendFormData = async ({ sendData }) => {
    //console.log(sendData)

    const data = {
      Data: sendData,
    };
    setIsLoadingOpen(true);

    if (
      hasDecimal(sendData.Nihss) ||
      hasDecimal(sendData.Weight) ||
      hasDecimal(sendData.InjectDose)
    ) {
      alert("請輸入整數");
      // 檢核不通過也要把「資料檢核中...」關掉，
      // 否則 backdrop="static" 的 Modal 會蓋住畫面，使用者只能重新整理。
      setIsLoadingOpen(false);
    } else {
      const res = await apiClient.postAes(
        "api/referral/SetReferral/Security",
        data
      );
      if (res?.status === 401) {
        alert("您的授權已失效，請重新登入");
        setIsLoadingOpen(false);
        navigate("/Login");
        return;
      }
      if (res?.status !== 200) {
        alert("存檔失敗");
        setIsLoadingOpen(false);
        return;
      }
      if (+res.data.Code !== 0) {
        alert(res.data.Message);
        setIsLoadingOpen(false);
        return;
      }
      const messageRowId = res.data.Data.MessageRowId;
      // 上傳失敗要回滾剛新增的轉診資料，先取好 RowId 供下方兩個失敗分支使用。
      const dataRowId = res.data.Data?.DataRowId;
      if (sendMediaData?.length > 0) {
        const fd = new FormData();
        //console.log(sendMediaData);

        sendMediaData.forEach((image) => {
          fd.append("ByFiles", image);
        });
        fd.append("DataRowId", messageRowId);
        //fd.append("AccountRowId", accountId);
        fd.append("AccountRowId", currentAccountRowId);
        fd.append("IsInsert", true);
        fd.append("Type", 2);
        // await apiClient.logOfActionWithoutId('addDataTitle','upload before',{
        //   messageRowId,currentAccountRowId
        // })
        apiClient.logOfActionWithoutId("Upload", "AddReferralBefore", {
          version,
          token,
          messageRowId,
        });
        try {
          // 變數名稱不可再用 res，否則會遮蔽外層 SetReferral 的回應。
          const uploadRes = await axios.post(
            `${apiUrl}api/referral/Upload`,
            fd,
            {
              headers: {
                Authorization: `${currentToken}`,
              },
            }
          );
          apiClient.logOfActionWithoutId("Upload", "AddReferralCompleted", {
            version,
            token,
            messageRowId,
          });
          if (+uploadRes.data.Code !== 0) {
            alert(uploadRes.data.Message);
            await deleteReferral(dataRowId);
            setIsLoadingOpen(false);
            return;
          }
        } catch (e) {
          if (e.response?.status !== 200) {
            alert("上傳檔案失敗");
            await deleteReferral(dataRowId);
            setIsLoadingOpen(false);
            return;
          }
        }
      }
      alert("新增成功");
      navigate("/ReferralDataList");
      setIsLoadingOpen(false);
    }
  };

  const { data, mutate, isSuccess, isLoading } = useMutation(sendFormData);

  const { data: FormResData } = data || {};
  // console.log(FormResData);

  //console.log(messageRowId);
  const version = import.meta.env.VITE_VERSION;

  // useEffect(() => {
  //   const code = +FormResData?.Code;
  //   if (FormResData !== undefined) {
  //     if (code !== 0) {
  //       alert(FormResData?.Message);
  //       setIsLoadingOpen(false);
  //     } else {
  //       alert("新增成功");
  //       navigate("/ReferralDataList");
  //       setIsLoadingOpen(false);
  //     }
  //   }
  // }, [FormResData]);

  const deleteReferral = async (dataRowId) => {
    const data = { Data: { RowId: dataRowId } };
    const res = await apiClient.postAes(
      "api/referral/DeleteReferral/Security",
      data
    );
  };

  // console.log(code);

  return (
    <Container>
      <div className="title">新增緊急轉診</div>
      <div className="btn">
        <div>
          <CssCancelButton
            size="small"
            variant="outlined"
            style={{ minWidth: "70px" }}
            onClick={handleOpen}
          >
            取消
          </CssCancelButton>
        </div>
        <div>
          <CssSaveButton
            size="small"
            variant="contained"
            style={{ minWidth: "70px" }}
            onClick={() => {
              mutate({ sendData });
            }}
          >
            存檔
          </CssSaveButton>
        </div>
      </div>
      <Modal open={open} onClose={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>提示資訊</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "100px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <div style={{ fontSize: "18px" }}>若有資料未儲存</div>
          <div style={{ fontSize: "14px" }}>「確認」取消將不保留您的資料</div>
        </Modal.Body>
        <Modal.Footer>
          <RsuiteBtn
            onClick={() => {
              navigate("/ReferralDataList");
            }}
            appearance="primary"
          >
            確認
          </RsuiteBtn>
          <RsuiteBtn onClick={handleClose}>取消返回</RsuiteBtn>
        </Modal.Footer>
      </Modal>
      <Modal open={isLoadingOpen} backdrop="static">
        <Modal.Body
          style={{
            height: "100px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <div style={{ fontSize: "14px" }}>資料檢核中...</div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </Container>
  );
}

export default AddDataTitle;
